import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectErrorPopupCode } from 'store/selectors'
import { hideErrorPopup } from 'store/actions/popup'
import { ERROR_POPUP } from './config'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const GlobalErrorPopup = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const errorCode = useSelector(selectErrorPopupCode)

  const onClose = useCallback(() => {
    dispatch(hideErrorPopup())
  }, [dispatch])

  const message = useMemo(() => {
    let title = t('global_error_popup.default.title', { errorCode })

    switch (errorCode) {
      case -336:
        return {
          title: t('global_error_popup.336.title'),
          content: t('global_error_popup.336.content'),
        }
      case -347:
        return {
          title,
          content: t('global_error_popup.-347.content'),
        }
      case -352:
        return {
          title,
          content: t('global_error_popup.-352.content'),
        }
      case -377:
        return {
          title,
          content: t('global_error_popup.-377.content'),
        }
      case -378:
        return {
          title,
          content: t('global_error_popup.-378.content'),
        }
      case ERROR_POPUP.GROUP_CREATE_LIMIT:
        return {
          title: t('global_error_popup.group_create_limit.title'),
          content: t('global_error_popup.group_create_limit.content'),
          buttonText: t('common.yes'),
        }
      case ERROR_POPUP.FILE_SIZE_OVER_MAX_LIMIT:
        return {
          title: t('postbox.image_too_big_alert.title'),
          content: t('postbox.image_too_big_alert.content'),
        }
      case ERROR_POPUP.FILE_DIMENSION_OVER_MAX_LIMIT:
        return {
          title: t('postbox.image_too_big_alert.title'),
          content: t('postbox.image_dimension_too_big_alert.content'),
        }
      case ERROR_POPUP.INVALID_IMAGE_FORMAT_UPLOAD:
        return {
          title: t('postbox.image_type_not_support.title'),
          content: t('postbox.image_type_not_support.content'),
        }
      case ERROR_POPUP.IMAGE_CONTAIN_BANNED_URL:
        return {
          title: t('postbox.image_contain_banned_url.title'),
        }
      default:
        return undefined
    }
  }, [errorCode])

  if (typeof message === 'undefined') {
    return null
  }

  return (
    <ConfirmBoxBasic
      onClose={onClose}
      onOk={onClose}
      isActive
      title={message.title}
      content={message.content}
      confirmButtonText={message.buttonText}
    />
  )
}

export default GlobalErrorPopup
